import { useEffect, useState } from 'react';
import { useAlertContext } from '../../../../Context/AlertContext';
import ConnectionService from '../../../../../services/ConnectionService';
import { buildApiUrl } from '../../../../../services/api';
import { useSearchParams } from 'react-router-dom';
import useLocale from '../../../../../CustomHooks/useLocale';
import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { NAVIGATION_ROUTES } from '../../../../../const';
import poweredByStravaImg from '../../../../../assets/images/powered_by_strava.png';
import classes from '../../Cabinet.module.css';
import { Stack } from '@mui/material';

type Connections = {
    [key: string]: {
        createdAt: string;
    };
};

function StravaIcon() {
    return (
        <SvgIcon>
            <svg
                className={classes['cabinet-connections__strava-icon']}
                width="193"
                height="48"
                viewBox="0 0 193 48"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g fill="none" fillRule="evenodd">
                    <rect fill="#FC4C02" x="4" y="4" width="185" height="40" rx="2" />
                    <path
                        d="m27 25.16 1.74.35c-.12 1.1-.52 2-1.2 2.68a3.65 3.65 0 0 1-2.68 1.02 3.93 3.93 0 0 1-3.05-1.3c-.79-.87-1.18-2.17-1.18-3.9 0-1.6.41-2.84 1.24-3.71a3.95 3.95 0 0 1 2.97-1.31c1.02 0 1.88.32 2.58.96a3.9 3.9 0 0 1 1.23 2.53l-1.7.26c-.25-1.48-.94-2.22-2.1-2.22-.71 0-1.31.29-1.8.86-.47.58-.71 1.47-.71 2.66 0 1.23.23 2.14.7 2.74.48.6 1.08.9 1.82.9 1.22 0 1.93-.84 2.14-2.52Zm6.52 2.6c.55 0 1-.2 1.34-.64a2.9 2.9 0 0 0 .5-1.83c0-.78-.16-1.4-.5-1.83a1.62 1.62 0 0 0-1.34-.65c-.56 0-1.01.22-1.35.65a2.89 2.89 0 0 0-.51 1.83c0 .8.17 1.42.5 1.84.35.43.8.64 1.36.64Zm0 1.45c-1 0-1.82-.35-2.47-1.04a4.05 4.05 0 0 1-.98-2.88c0-1.21.34-2.17 1-2.87a3.25 3.25 0 0 1 2.45-1.05c.96 0 1.77.35 2.43 1.05.66.7.98 1.66.98 2.87 0 1.23-.31 2.2-.95 2.88a3.2 3.2 0 0 1-2.46 1.04Zm5.24-.21v-7.42h1.54v.71h.03c.2-.26.5-.48.86-.65.36-.18.74-.27 1.14-.27.82 0 1.47.24 1.94.73.47.5.7 1.17.7 2.04l.01 4.86H43.4v-4.44c0-1.15-.48-1.72-1.44-1.72-.49 0-.88.14-1.17.42a1.5 1.5 0 0 0-.43 1.13V29h-1.6Zm8.47 0v-7.42h1.54v.71h.03c.2-.26.49-.48.85-.65.36-.18.75-.27 1.15-.27.82 0 1.47.24 1.94.73.47.5.7 1.17.7 2.04V29h-1.58v-4.44c0-1.15-.48-1.72-1.44-1.72-.49 0-.87.14-1.16.42a1.5 1.5 0 0 0-.44 1.13V29h-1.6Zm13.4-2.46 1.14.93a3.42 3.42 0 0 1-3.08 1.74 3.24 3.24 0 0 1-2.51-1.07 4.07 4.07 0 0 1-.98-2.85c0-1.19.32-2.13.97-2.85a3.16 3.16 0 0 1 2.45-1.07c.99 0 1.8.35 2.43 1.06.63.71.94 1.67.94 2.86v.48h-5.18c.02.61.2 1.1.51 1.47.33.37.77.56 1.34.56.27 0 .51-.04.73-.12.21-.07.4-.18.57-.33a3 3 0 0 0 .66-.81Zm-3.8-1.98h3.6c-.02-.52-.19-.95-.5-1.28-.3-.33-.74-.5-1.31-.5-.53 0-.96.18-1.27.54a2 2 0 0 0-.52 1.24Zm11.5 1.49 1.58.33c-.15.9-.49 1.6-1.02 2.09-.53.5-1.24.74-2.11.74-1.01 0-1.84-.35-2.48-1.04a4.07 4.07 0 0 1-.97-2.88c0-1.19.33-2.13.97-2.85a3.18 3.18 0 0 1 2.46-1.07c.85 0 1.55.25 2.1.76s.87 1.17.97 1.98l-1.5.26c-.16-1.04-.68-1.56-1.55-1.56-.57 0-1.03.22-1.36.65-.34.44-.5 1.05-.5 1.83s.16 1.4.48 1.83c.33.43.79.65 1.38.65.86 0 1.38-.58 1.55-1.72Zm3.69.47v-3.57H70.9v-1.37h1.16v-1.82h1.51v1.82h1.87v1.37h-1.85v3.4c0 .41.06.7.19.86.12.17.38.25.77.25h.6V29h-.72c-.9 0-1.52-.2-1.88-.6-.35-.4-.53-1.02-.53-1.88ZM81.99 29l-1.64-7.42h1.57l1.05 5.17H83l1.76-5.17h1.45l1.65 5.15h.03l1.19-5.15h1.54L88.84 29H87.3l-1.8-5.57h-.04L83.52 29h-1.53Zm10.41 0v-7.42H94V29h-1.6Zm-.03-8.64v-1.58h1.66v1.58h-1.66Zm4.33 6.16v-3.57h-1.12v-1.37h1.16v-1.82h1.51v1.82h1.86v1.37h-1.85v3.4c0 .41.07.7.2.86.12.17.38.25.77.25h.59V29h-.72c-.9 0-1.52-.2-1.87-.6-.36-.4-.53-1.02-.53-1.88Zm5.17 2.48V18.78h1.6v3.53h.02a2.63 2.63 0 0 1 1.99-.94c.8 0 1.44.24 1.93.73.5.48.75 1.15.75 1.99V29h-1.59v-4.54c0-.48-.13-.87-.39-1.17-.26-.3-.64-.45-1.13-.45-.48 0-.86.14-1.15.42-.29.28-.43.64-.43 1.08V29h-1.6ZM160.02 18.72l-2.45 4.97-2.44-4.97h-3.6L157.58 31l6.03-12.28h-3.58Zm-19.85 4.34c0-.37-.13-.65-.39-.83-.25-.18-.6-.27-1.04-.27h-1.63v2.26h1.62c.44 0 .8-.1 1.05-.3.26-.2.39-.47.39-.82v-.04Zm9-5.06 6.04 12.28h-3.6l-2.43-4.97-2.44 4.97h-6.72l-2.11-3.3h-.8v3.3h-3.75V18.72h5.48c1 0 1.83.12 2.47.36.65.24 1.17.56 1.56.97.35.35.6.74.77 1.18.17.44.26.96.26 1.55v.04a3.73 3.73 0 0 1-2.21 3.53l1.95 2.93L149.18 18Zm16.8 0-6.04 12.28h3.6l2.44-4.97 2.44 4.97H172L165.97 18Zm-43.48 3.99h3.3v8.29h3.74v-8.29h3.3v-3.27H122.5V22Zm-.14 3.07c.23.4.35.9.35 1.49v.03c0 .6-.12 1.15-.36 1.63-.23.49-.56.9-.99 1.23-.43.34-.94.6-1.55.78-.61.18-1.3.27-2.05.27-1.14 0-2.2-.16-3.2-.49a7.02 7.02 0 0 1-2.55-1.46l2-2.45c.6.48 1.25.83 1.92 1.04.67.2 1.34.3 2 .3.35 0 .6-.04.74-.12.15-.1.22-.21.22-.37v-.03c0-.16-.1-.3-.32-.41a5.58 5.58 0 0 0-1.23-.35c-.63-.13-1.23-.29-1.8-.46a6.1 6.1 0 0 1-1.5-.68 2.89 2.89 0 0 1-1.42-2.57v-.04c0-.55.1-1.06.31-1.53.2-.47.51-.89.91-1.24s.9-.63 1.5-.82c.58-.2 1.26-.3 2.03-.3 1.1 0 2.04.13 2.86.4.82.26 1.55.65 2.2 1.18l-1.82 2.61a5.55 5.55 0 0 0-3.36-1.14c-.28 0-.49.04-.62.13a.4.4 0 0 0-.2.35v.03c0 .16.1.29.3.4.2.1.6.22 1.19.35.71.13 1.36.29 1.95.47.59.2 1.1.43 1.52.72.42.3.74.64.97 1.05Z"
                        fill="#FFF"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

function CabinetProfileConnections() {
    const { localeUrlPrefix } = useLocale();
    const intl = useIntl();
    const [urlSearchParams, setUrlSearchParams] = useSearchParams();
    const [connections, setConnections] = useState<Connections>({});
    const showAlert = useAlertContext();

    const buildOauthConnectLink = (appId: string) => {
        // TODO просто использовать текущий url
        const redirectUrl = `${localeUrlPrefix}${NAVIGATION_ROUTES.cabinet}?from=oauth-authorize`;

        return `${buildApiUrl('/connection/oauth/connect')}?redirectUrl=${encodeURIComponent(
            redirectUrl
        )}&appId=${appId}`;
    };

    const handleUnConnectClick = (appId: string) => {
        return async () => {
            const { status } = await ConnectionService.unConnect({ appId });

            if (status) {
                const newConnections = {
                    ...connections
                };

                delete newConnections[appId];

                setConnections(newConnections);
                showAlert(
                    intl.formatMessage({
                        defaultMessage: 'Приложение успешно отключено.',
                        id: 'Cabinet_AppUnconnectMessage',
                        description: 'кнопка unconnect'
                    }),
                    'info'
                );
            }
        };
    };

    useEffect(() => {
        ConnectionService.get().then((res) => {
            setConnections(res.connections);
        });
    }, []);

    useEffect(() => {
        const fromParam = urlSearchParams.get('from');

        if (fromParam === 'oauth-authorize') {
            const errorParam = urlSearchParams.get('oauth-authorize-error');

            if (errorParam) {
                showAlert(errorParam, 'error');
            }

            urlSearchParams.delete('from');
            urlSearchParams.delete('oauth-authorize-error');

            setUrlSearchParams(urlSearchParams, {
                replace: true
            });
        }
    }, []);

    return (
        <section className={classes['cabinet-tabs__section']} aria-labelledby="connections_title">
            <Typography
                variant="h3"
                component="h2"
                className={classes['cabinet-tabs__title']}
                id="connections_title"
            >
                <FormattedMessage
                    defaultMessage="Подключённые сервисы"
                    id="Cabinet_ConnectionsSectionTitle"
                    description="Кабинет"
                />
            </Typography>
            <p className={classes['cabinet-tabs__text']}>
                <FormattedMessage
                    defaultMessage="Подключите аккаунты сторонних сервисов"
                    id="Cabinet_ConnectionsSectionDescription"
                    description="кабинет"
                />
            </p>
            <Stack spacing={3}>
                <Stack spacing={2}>
                    <div>
                        {connections.strava ? (
                            <FormattedMessage
                                defaultMessage="Ваша учётная запись Strava привязана. Если тренировки не выгружаются, попробуйте нажать кнопку «Переподключить»."
                                id="Cabinet_ConnectionsSectionDescConnected"
                                description="кабинет"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Привяжите свою учётную запись из Strava. Однократно потребуется включить VPN, чтобы перейти на сайт Strava."
                                id="Cabinet_ConnectionsSectionDesc"
                                description="кабинет"
                            />
                        )}
                    </div>
                    {
                        connections.strava && (
                            <img
                                src={poweredByStravaImg}
                                alt="Powered by Strava"
                                className={classes['cabinet-connections__strava-logo']}
                            />
                        )
                    }
                    <Stack direction="row" spacing={2}>
                        {
                            connections.strava ? (
                                <>
                                    <Button
                                        variant="outlined"
                                        onClick={handleUnConnectClick('strava')}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Отключить"
                                            id="Cabinet_disconnectButton"
                                            description="кабинет"
                                        />
                                    </Button>
                                    <Button
                                        href={buildOauthConnectLink('strava')}
                                        variant="outlined"
                                    >
                                        <FormattedMessage
                                            defaultMessage="Переподключить"
                                            id="Cabinet_reconnectButton"
                                            description="кабинет"
                                        />
                                    </Button>
                                </>
                            ) : (
                                <IconButton
                                    disableRipple
                                    className={classes['cabinet-connections__strava-button']}
                                    aria-label={intl.formatMessage({
                                        defaultMessage: 'Подключить Strava',
                                        id: 'Cabinet_connectStravaButton',
                                        description: 'кабинет'
                                    })}
                                    href={buildOauthConnectLink('strava')}
                                >
                                    <StravaIcon />
                                </IconButton>
                            )
                        }
                    </Stack>
                </Stack>
                <Stack spacing={2}>
                    <div>
                        {connections.intervals ? (
                            <FormattedMessage
                                defaultMessage="Ваша учётная запись Intervals.icu привязана. Если тренировки не выгружаются, попробуйте нажать кнопку «Переподключить»."
                                id="Cabinet_ConnectionsIntervalsSectionDescConnected"
                                description="кабинет"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Привяжите свою учётную запись Intervals.icu."
                                id="Cabinet_ConnectionsIntervalsSectionDesc"
                                description="кабинет"
                            />
                        )}
                    </div>
                    <Stack spacing={2} direction="row">
                        {connections.intervals ? (
                            <>
                                <Button
                                    variant="outlined"
                                    onClick={handleUnConnectClick('intervals')}
                                >
                                    <FormattedMessage
                                        defaultMessage="Отключить"
                                        id="Cabinet_disconnectButton"
                                        description="кабинет"
                                    />
                                </Button>
                                <Button
                                    variant="outlined"
                                    href={buildOauthConnectLink('intervals')}
                                >
                                    <FormattedMessage
                                        defaultMessage="Переподключить"
                                        id="Cabinet_reconnectButton"
                                        description="кабинет"
                                    />
                                </Button>
                            </>
                        ) : (
                            <Button
                                variant="contained"
                                href={buildOauthConnectLink('intervals')}
                            >
                                <FormattedMessage
                                    defaultMessage="Подключить"
                                    id="Cabinet_connectButton"
                                    description="кабинет"
                                />
                            </Button>
                        )}
                    </Stack>
                </Stack>
                <Stack spacing={2}>
                    <div>
                        {connections.polar ? (
                            <FormattedMessage
                                defaultMessage="Ваша учётная запись Polar привязана. Если тренировки не выгружаются, попробуйте нажать кнопку «Переподключить»."
                                id="Cabinet_ConnectionsPolarSectionDescConnected"
                                description="кабинет"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Привяжите свою учётную запись Polar."
                                id="Cabinet_ConnectionsPolarSectionDesc"
                                description="кабинет"
                            />
                        )}
                    </div>
                    <Stack spacing={2} direction="row">
                        {connections.polar ? (
                            <>
                                <Button
                                    variant="outlined"
                                    onClick={handleUnConnectClick('polar')}
                                >
                                    <FormattedMessage
                                        defaultMessage="Отключить"
                                        id="Cabinet_disconnectButton"
                                        description="кабинет"
                                    />
                                </Button>
                                <Button
                                    variant="outlined"
                                    href={buildOauthConnectLink('polar')}
                                >
                                    <FormattedMessage
                                        defaultMessage="Переподключить"
                                        id="Cabinet_reconnectButton"
                                        description="кабинет"
                                    />
                                </Button>
                            </>
                        ) : (
                            <Button
                                variant="contained"
                                href={buildOauthConnectLink('polar')}
                            >
                                <FormattedMessage
                                    defaultMessage="Подключить"
                                    id="Cabinet_connectButton"
                                    description="кабинет"
                                />
                            </Button>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </section>
    );
}

export default CabinetProfileConnections;
